import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Details = props => {
  return (
    <SvgIcon {...props}>
      <path d="M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z" />
    </SvgIcon>
  );
};

export default SvgI24Details;
